<template>
  <v-dialog
    persistent
    overlay-opacity=".7"
    v-model="internalValue"
    max-width="55%"
    class="rounded-lg"
    style="z-index: 99999 !important"
  >
    <v-card class="elevation-0 py-5 px-10">
      <div v-html="formattedTextInfo" class="mx-auto text-center pa-5" />
      <div>
        <v-checkbox
          v-model="checkList"
          class="mx-4 px-4"
          label="Concordo com os termos"
        ></v-checkbox>
      </div>
      <div class="d-flex align-center justify-space-between my-2 elevation-0 flex-wrap mx-4 flex-gap-4">
        <v-btn
          @click="handleUserSignUp(true)"
          :disabled="!checkList"
          color="primary"
          ><span class="black--text">{{ $t("instructions.confirmAndAccept") }}</span></v-btn
        >
        <v-btn
          @click="handleUserSignUp(false)"
          outlined
          color="red"
          >{{ $t("instructions.notAccepted") }}</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { useAuthStore } from "@/store/authStore";
import { mapActions } from "pinia";

export default {
  name: "firstLogin",
  props: {
    value: { type: Boolean, required: true },
  },
  data() {
    return {
      pdfUrl: "/pdf/tos_blank.pdf",
      checkList: false,
      checkSnackBar: false,
      brokerId: null,
    };
  },
  watch: {
    checkList(v) {
      this.checkSnackBar = v;
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["confirmFirstLogin"]),
    downloadFile() {
      const filename = `FX Partner - Service Agreement.pdf`;
      const link = document.createElement("a");
      link.href = this.pdfUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    async handleUserSignUp(val) {
      if (val) {
        await this.confirmFirstLogin();
      }
      else {
        this.$router.push("/login")

      }
      this.internalValue = false;
    },
  },
  computed: {
    handlePdfUpload() {
      return `${this.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=120`;
    },
    formattedTextInfo() {
      const info = JSON.parse(localStorage.getItem("userInfo")) || {};

      //const formattedCnpj = info.cnpj ? convertToCNPJ(info.cnpj) : '-'
      // const name = info.name?.trim() || info.companyName?.trim()

      if (!info) return "";
      return `
    <span class="mt-2 text-caption text-info">
        Declaro que li, compreendi e aceito os
        <a 
         href="${this.handlePdfUpload}"
          download="Contrato de Usuário e Acesso Eletrônico.pdf"
          style="border-bottom: 1px solid #0073ff; cursor: pointer; text-decoration:none"
        >
	  termos para uso e acesso eletrônico</a> a esta plataforma, incluindo
	    seus recursos de negociação, informações e dados de mercado,
		    ferramentas analíticas, algoritmos, mensagens, conteúdos e
	    demais funcionalidades.</br>
		    E-mail: ${info.email ? "<b>" + info.email + "</b>, " : ""}</br>
		    Empresa: <b>ABC</b> (<b>cnpj</b>)
      </span>
    `;
    },
    toggleCheckList() {
      return this.checkList;
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>

<style>
.v-dialog {
  scrollbar-width: none;
}

.snackbar-margin {
  position: absolute;
  top: 45%;
}
</style>
<style scoped>
::v-deep .text-info {
  font-size: 1rem !important;
  line-height: 1.5;
}
</style>
